<template>
  <button @click="click" class="modal-launcher">
    <div class="modal-launcher__content" v-html="parsedDescription"></div>
  </button>
</template>

<script>
import showdown from "showdown";

export default {
  name: "ModalLauncher",
  props: {
    description: {
      type: String,
      default: undefined
    }
  },
  computed: {
    parsedDescription: function() {
      const converter = new showdown.Converter();
      const convertedString = converter.makeHtml(this.description);
      return convertedString;
    }
  },
  methods: {
    click: function() {
      return this.$emit("click");
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-launcher {
  cursor: pointer;
  background-color: transparent;
  background-color: transparent;
  border-radius: sizes("border-radius");
  border: 0;
  display: block;
  max-width: 450px;
  padding: spacer("s");
  transition: cta-transition(background-color, 0.3s);

  &__content {
    color: theme-color("body");
    font-family: $font-family;
    font-size: px-to-rem(16px);
    font-weight: 400;
    text-align: center;
  }

  &:hover {
    background-color: rgba(theme-color("body"), 0.1);
  }
}
</style>
